import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  value: {
    role: {},
    newRole: false,
    loaded: false,
    deleted: false,
    deleteFailed: false,
    message: ""
  }
};
const roleSlice = createSlice({
  name: "roleInfo",
  initialState,
  reducers: {
    getRole: (state, action) => {
      state.value = {
        role: action.payload,
        newRole: false,
        loaded: true,
        deleted: false,
        deleteFailed: false,
        message: ""
      };
    },
    createRole: (state, action) => {
      state.value = {
        role: action.payload,
        newRole: true,
        loaded: true,
        deleted: false,
        deleteFailed: false,
        message: ""
      };
    },
    saveRole: (state, action) => {
      state.value = {
        role: action.payload,
        newRole: false,
        loaded: true,
        deleted: false,
        deleteFailed: false,
        message: ""
      };
    },
    deleteRole: (state, action) => {
      state.value = {
        role: {},
        newRole: false,
        loaded: false,
        deleted: true,
        deleteFailed: false,
        message: ""
      };
    },
    deleteFailedRole: (state, action) => {
      state.value = {
        role: {},
        newRole: false,
        loaded: false,
        deleted: false,
        deleteFailed: true,
        message: action.payload
      };
    }
  }
});
export const { getRole, saveRole, createRole, deleteRole, deleteFailedRole } = roleSlice.actions;
export default roleSlice.reducer;
